import { useState } from "react";
import { postForm } from "../lib/api";

export function useFormState(initial) {
  const [values, setValues] = useState(initial);
  const [errors, setErrors] = useState({});
  const update = (k) => (e) => {
    const v = e.target.value;
    setValues((s) => ({ ...s, [k]: v }));
    if (errors[k]) setErrors((s) => ({ ...s, [k]: null }));
  };
  return { values, errors, setErrors, update };
}

export function useSubmit(form) {
  const [pending, setPending] = useState(false);
  const [done, setDone] = useState(false);
  const [serverError, setServerError] = useState(null);

  const submit = async (body) => {
    setPending(true);
    setServerError(null);
    const { ok, data } = await postForm(form, body);
    setPending(false);
    if (ok) {
      setDone(true);
      return true;
    }
    const d = data && data.detail;
    const msg =
      (d && d.message) ||
      (d && d.error === "rate_limited" ? "Too many submissions from this connection. Please try again later." : "Could not send. Please try again.");
    setServerError(msg);
    return false;
  };

  return { pending, done, serverError, submit };
}

export function firstErrorFocus(errors) {
  const k = Object.keys(errors).find((key) => errors[key]);
  if (!k) return;
  const el = document.getElementById(k);
  if (el) el.focus();
}
